import { dateRangeBoundsSchema } from 'lib/dateRangeBoundsSchema'
import { z } from 'zod'

export const filtersSchema = z.object({
  timeRange: z.object({
    dateRange: dateRangeBoundsSchema,
  }),
  user: z.object({
    userId: z.number().nullable(),
  }),
  status: z.object({
    statuses: z.array(z.string()),
  }),
  eventType: z.object({
    eventTypes: z.array(z.string()),
  }),
  eventSubType: z.object({
    eventSubTypes: z.array(z.string()),
  }),
  type: z.object({
    types: z.array(z.string()),
  }),
  paymentProvider: z.object({
    providers: z.array(z.string()),
  }),
  paymentId: z.object({
    id: z.number().nullable(),
  }),
  shiftId: z.object({
    id: z.number().nullable(),
  }),
  companyId: z.object({
    id: z.number().nullable(),
  }),
})

export type FiltersSchema = z.infer<typeof filtersSchema>
